module.exports = __webpack_public_path__ + "static/img-how-use-cl-751d5bc7c18597930cbe650dbb0de052.png";